import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ChevronRight, AlertTriangle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { MasterAiConfig } from "@/components/MasterAiConfig";

const CRIMSON = "#bf3b4f";

/** Every section that uses AI, the model it's on, and where to change it. */
function AiSections() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.aiSections().then((r) => setRows(r.sections)).catch(() => setRows([])); }, []);
  return (
    <div className="bg-white border border-slate-200 rounded-lg mb-5" data-testid="ai-sections">
      <div className="px-4 py-3 border-b border-slate-100">
        <h2 className="text-sm font-semibold text-slate-700">AI by section</h2>
        <p className="text-[11px] text-slate-500">Each section chooses its own model from the registry below. Changing one doesn't affect the others.</p>
      </div>
      {rows === null ? (
        <div className="flex justify-center py-4"><Loader2 className="h-4 w-4 animate-spin text-slate-400" /></div>
      ) : (
        <div className="divide-y divide-slate-100">
          {rows.map((s) => (
            <Link key={s.key} to={s.path} className="flex items-center gap-3 px-4 py-2.5 hover:bg-slate-50 group" data-testid={`ai-section-${s.key}`}>
              <div className="min-w-0 flex-1">
                <div className="text-sm text-slate-800">{s.label}</div>
                <div className="text-[11px] text-slate-400">Change in {s.where}</div>
              </div>
              <div className="text-right text-xs">
                {s.model ? (
                  <span className={s.in_registry ? "text-slate-600" : "text-amber-700"}>
                    {!s.in_registry && <AlertTriangle className="h-3 w-3 inline mr-1" />}
                    {s.model_label || s.model}
                  </span>
                ) : <span className="text-slate-400">Couldn't read</span>}
                {s.model && !s.in_registry && <div className="text-[10px] text-amber-700">Not in the registry</div>}
              </div>
              <ChevronRight className="h-4 w-4 text-slate-300 group-hover:text-slate-500" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default function AiSettings() {
  return (
    <div className="p-5 max-w-3xl">
      <div className="flex items-center gap-2.5 mb-1">
        <Sparkles className="h-5 w-5" style={{ color: CRIMSON }} />
        <h1 className="text-xl font-semibold text-slate-800">AI Settings</h1>
      </div>
      <p className="text-sm text-slate-500 mb-5">
        Manage the global Bedrock model registry and AWS credentials. Each section that uses AI selects its model from
        this registry and has its own independent settings.
      </p>
      <AiSections />
      <MasterAiConfig />
    </div>
  );
}
